<template>
  <b-badge
    v-if="text"
    class="expiration-badge"
    :class="{ 'expiration-badge-warning': variant === 'warning' }"
    :title="text"
    :variant="variant"
  >
    <font-awesome-icon
      class="mr-50"
      icon="clock"
    />{{ text }}
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BADGE_PREFIX, expirationDateDisplay, getExpirationVariant } from '@/helpers/expiration-helpers'

export default {
  name: 'ExpirationBadge',
  components: {
    BBadge,
    FontAwesomeIcon,
  },
  props: {
    expirationDate: {
      type: String,
      default: null,
    },
  },
  computed: {
    text() {
      const display = expirationDateDisplay(
        this.expirationDate,
        ymd => this.dateHelpers.format(ymd, 'DD/MM/YYYY'),
      )
      return display ? `${BADGE_PREFIX} ${display}` : ''
    },
    variant() {
      return getExpirationVariant(this.expirationDate)
    },
  },
}
</script>

<style scoped>
.expiration-badge {
  white-space: normal;
  text-align: left;
}

/* Vuexy's white text on amber is below WCAG AA (UI-SPEC Color Contrast) */
.expiration-badge-warning {
  color: #343a40;
}
</style>
